<template>
    <div class="c-product-group" :class="{'pim-disabled': group.IsPIMDisabled}" :title="[group.IsPIMDisabled ? $t('product_group.pim_disabled', {product: group.ErpId + ' - ' + group.Name}) : '']">
        <h3 class="u-semi-bold c-product-group-line__title" :class="{'isDisabled' : isDisabled}">
            <slot name="title"></slot>
            <div class="c-product-group-controls">
                <v-input v-if="showSortIndex" 
                         v-model.number="group.SortIndex" 
                         type="number"
                         input-size="tiny"
                         name="sortIndex"
                         width="50px"
                         :min=0
                         @change="$emit('updateSortIndex')"/>
                <button class="c-toggle-variations-visibility" @click="collapseAllVariations = !collapseAllVariations"
                        :aria-label="$t('product.line.collapse_variations')" :class="{'is-collapsed' : collapseAllVariations}">
                    <svgicon width=".4em" height=".4em" name="arrow-rounded"
                            class="c-product-line__arrow svg-down"></svgicon>
                </button>
            </div>            
        </h3>
        <div v-if="!isMarketing" class="c-product-line c-product-group-line u-pos-relative" :class="{'isDisabled' : isDisabled}">
            <div class="c-product-group-line-inner o-gutter">
                <slot name="product"></slot>
            </div>
        </div>
        <transition name="collapse">
            <div v-if="!collapseAllVariations" class="c-product-variations">
                <slot name="variations"></slot>
            </div>
        </transition>
    </div>
</template>


<script>
    import Vue from 'vue'
    import VInput from '@/components/form/Input'

    export default {
        props: {
            group: Object,
            collapseAllVariations: Boolean,
            isMarketing: { type: Boolean, default: false },
            showSortIndex: { type:Boolean, default: false}
        },
        components: {
            VInput
        },
        computed: {
            isDisabled() {
                return typeof this.group.IsDeleted !== 'undefined' && this.group.IsDeleted;
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-product-group {
        &:not(:last-child) {
            margin-bottom: em($global-spacing-unit-medium);
        }
    }

    .c-product-group-line {
        border: 1px solid $color-neutral;
        padding: em($global-spacing-unit);
        background-color: white;
    }

    .c-product-group-line,
    .c-product-group-line__title {
        &.isDisabled {
            opacity: .3;
        }
    }

    .c-product-group-line__title {
        font-style: normal;
        padding: em($global-spacing-unit-tiny) 0;
        border-bottom: 1px solid $color-neutral;
        margin-bottom: -1px;
        background-color: white;
        z-index: 2;
        position: sticky;
        top: 0;

        .is-marketing-line & {
            color: $color-info;
            border-color: $color-info;
        }
    }

    .c-product-group-line-inner {
        display: flex;
        flex-wrap: wrap;

        > * {
            flex: 1 1 auto;
            @include down($mobile-landscape) {
                &:not(:last-child) {
                    margin-bottom: em($global-spacing-unit);
                }
            }
        }
    }

    .c-product-variations {
        transform-origin: 50% 0;
    }

    .collapse-enter-active,
    .collapse-leave-active {
        transition: .25s ease-out;
    }

    .collapse-enter,
    .collapse-leave-to {
        opacity: 0;
        transform: scaleY(0);
    }

    .pim-disabled {
        border: 4px solid $color-error;
        padding: 4px;
    }

</style>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-product-group-line {
        .c-gallery {
            display: flex;
        }
        .c-gallery-main {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            height: 180px;
            width: 230px;
            margin-right: em($global-spacing-unit-small);

            img {
                max-height: 180px;
                max-width: 230px;
            }
        }
    }

    .c-product-group-controls {
        float:right;
        display: inline-block;

        .c-form-item--horizontal {
            display: inline-block !important;
        }
    }

    .c-sort-index {
        margin-right: em($global-spacing-unit-small);
        width:50px;
    }

    .c-toggle-variations-visibility {
        border: none;
        color: $color-alpha;
        transition: .15s ease-out;

        &:focus {
            box-shadow: none !important;
        }

        &.is-collapsed {
            transform: rotate(90deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/product/layout/ProductLineLayout.vue